import React, {Component} from 'react'
import i18 from '../../i18'
import NotificationSystem from 'react-notification-system'
import api from '../../source/api'
import Modal from 'react-modal'
import Field from '../common/Field'
import Validator from '../common/Validator'
import Row from "./Rules/Row";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

Modal.setAppElement('#root');

class Rules extends Component {
    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            modalIsOpen: false,
            company: props.company,
            invoices: props.invoices,
            customerRules: props.customerRules,
            vatCollectorCodes: props.vatCollectorCodes,
            editRule: {},
            fields: {
                item_name: {value: '', error: '', role: {required: false}},
                invoice_number: {value: '', error: '', role: {required: false}},
                main_bookkeeping_number: {value: '', error: '', role: {required: true}},
                vat: {value: '', error: '', role: {required: true}},
                vat_degree: {value: '', error: '', role: {required: false}},
                collector_code_fk_id: {value: '', error: '', role: {required: true}},
                company_type: {value: '', error: '', role: {required: true}},
                type: {value: '', error: '', role: {required: true}},
                id: {value: '', error: '', role: {required: true}},
                position: {value: '', error: '', role: {required: true}}
            },
        }
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)
    };

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            company: nextProps.company,
            invoices: nextProps.invoices,
            customerRules: nextProps.customerRules,
            vatCollectorCodes: nextProps.vatCollectorCodes,
        })
    };

    onRemoveRule = (rule) => {
        if (window.confirm('Biztos törölni szeretné a szabályt?')) {
            api.delete({url: 'customer/rule/delete?company_id=' + this.state.company.id + '&id=' + rule.id}, true)
                .then((response) => {
                    this.props.updateInvoices(this.state.invoices, response.data.customerRules);
                    this.setState({modalIsOpen: false});
                    this._addNotification('Szabály törlése sikeres.', 'success', 10)
                });
        }
    };

    onEditRule = (rule) => {
        let fields = this.state.fields;

        fields.vat_degree.value = rule.vat_degree;
        fields.collector_code_fk_id.value = rule.collector_code_fk_id;
        fields.company_type.value = rule.company_type;
        fields.position.value = rule.position;
        fields.item_name.value = rule.item_name;
        fields.invoice_number.value = rule.invoice_number;
        fields.main_bookkeeping_number.value = rule.main_bookkeeping_number;
        fields.vat.value = rule.vat;
        fields.id.value = rule.id;
        fields.type.value = rule.type;

        this.setState({
            fields: fields,
            editRule: rule,
            modalIsOpen: true,
        })
    };

    updateRule = () => {
        let validator = Validator.validate(this.state.fields);
        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
            })
            return;
        }

        if (this.state.fields.item_name.value === '' && this.state.fields.invoice_number.value === '') {
            this._addNotification('Vagy a forgalom típusát vagy a számlaszámot ki kell tölteni!', 'error', 30);
            return false;
        }

        let postData = {
            id: this.state.fields.id.value,
            company_type: this.state.fields.company_type.value,
            position: this.state.fields.position.value,
            item_name: this.state.fields.item_name.value,
            invoice_number: this.state.fields.invoice_number.value,
            type: this.state.fields.type.value,
            main_bookkeeping_number: this.state.fields.main_bookkeeping_number.value,
            vat: this.state.fields.vat.value,
            vat_degree: this.state.fields.vat_degree.value,
            collector_code_fk_id: this.state.fields.collector_code_fk_id.value,
        };

        api.put({url: 'customer/rule/update?company_id=' + this.state.company.id, data: postData}, true)
            .then((response) => {
                this.props.updateInvoices(this.state.invoices, response.data.customerRules);
                this.setState({modalIsOpen: false});
                this._addNotification('Szabály szerkesztése sikeres.', 'success', 10)
            });
    };

    closeModal = () => {
        this.setState({modalIsOpen: false})
    };

    rulesTableHeader = () => {
        return (
            <tr>
                <th>Azonsító</th>
                <th>{i18.CUSTOMER._typeOfTraffic}</th>
                <th>{i18.CUSTOMER._invoiceNumber}</th>
                <th>{i18.CUSTOMER._mainBookNumber}</th>
                <th>{i18.CUSTOMER._VAT}</th>
                <th>{i18.CUSTOMER._collectorCode}</th>
                <th>{i18.CUSTOMER._taxNumber}</th>
                <th>{i18.CUSTOMER._vatDegreeNumber}</th>
                <th>{i18.COMMON._typeOfRule}</th>
                <th>{i18.COMMON._position}</th>
                <th>Módosítva</th>
                <th style={{width: '70px'}}>&nbsp;</th>
            </tr>
        );
    }

    listRules = () => {
        if (!this.state.customerRules) {
            return (
                <tr>
                    <td colSpan="10">{i18.COMMON._noRulesFound}</td>
                </tr>
            );
        }

        let savedRules = []
        for (let index in this.state.customerRules) {
            let rule = this.state.customerRules[index];
            let vatCode = this.state.vatCollectorCodes.find(x => x.id === rule.collector_code_fk_id);

            let id = rule.id + '-' + Math.random(9999, 99999);

            savedRules.push(
                <Row
                    _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                    key={id}
                    company={this.state.company}
                    rule={rule}
                    vatCode={vatCode}
                    vatCollectorCodes={this.state.vatCollectorCodes}
                    onRemoveRule={(rule) => this.onRemoveRule(rule)}
                    onEditRule={(rule) => this.onEditRule(rule)}/>
            )
        }
        return savedRules;
    };

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    };

    editRules = () => {
        this.props.editRules()
    };

    printPage = () => {
        window.print()
    };

    deleteAllRules = () => {
        if (!window.confirm('Biztos törölni szeretné az összes szabályt?')) {
            return;
        }

        api.get({url: 'customer/rules/deleteall?company_id=' + this.state.company.id, data: {}}, true)
            .then((response) => {
                this.props.updateInvoices(this.state.invoices, response.data.customerRules)
                this._addNotification('Összes szabály törlése sikeres.', 'success', 10)
            });
    }

    render = () => {
        return (
            <section id='customer-rules'>
                <div className='header'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1>
                                    <a onClick={() => this.editRules()} className='choose-btn'>{i18.BUTTONS._back}</a>
                                    {i18.CUSTOMER._rulesTitle}
                                </h1>
                                <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : null}</h4>
                            </div>
                            <div className='col-12'>
                                <p>
                                    {i18.CUSTOMER._rulesDescription}
                                </p>
                                <a className='link-color' onClick={() => this.printPage()}>
                                    <i className="fa fa-print" aria-hidden="true"/>&nbsp;{i18.COMMON._printRules}
                                </a>&nbsp;&nbsp;&nbsp;
                                <a className='link-color' onClick={() => this.deleteAllRules()}>
                                    <i className="fa fa-trash-o" aria-hidden="true"/>&nbsp;{i18.COMMON._deleteAllRules}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <table className='table table-striped  table-aibook-no-border'>
                                    <thead>
                                    {this.rulesTableHeader()}
                                    </thead>
                                    <tbody>
                                    {this.listRules()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.closeModal()}
                    style={customStyles}
                    contentLabel='Szabály szerkesztése'>
                    <h4>{i18.COMMON._editRuleText}</h4>
                    <div className='modal-body'>
                        <Field
                            type='text' id='item_name' name='item_name'
                            label={i18.CUSTOMER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='invoice_number' name='invoice_number'
                            label={i18.CUSTOMER._invoiceNumber} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='vat' name='vat'
                            label={i18.CUSTOMER._VAT} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <label htmlFor="company_type" className="margin-top-10 margin-bottom-2 control-label">{i18.CUSTOMER._taxNumber}</label>
                        <select value={this.state.fields.company_type.value}
                                name='company_type'
                                id='company_type'
                                onChange={(event) => this.onElementChange(event)}
                                className='minimal-100  form-control'>
                            <option value='EU'>{i18.COMMON._eu}</option>
                            <option value='HU'>{i18.COMMON._hu}</option>
                            <option value='NON_EU'>{i18.COMMON._non_eu}</option>
                        </select>
                        <Field
                            type='text' id='position' name='position'
                            label={i18.CUSTOMER._POSITION} classLabel='control-label margin-bottom-2 margin-top-10'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <Field
                            type='text' id='main_bookkeeping_number' name='main_bookkeeping_number'
                            label={i18.CUSTOMER._mainBookNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        <label htmlFor="collector_code_fk_id" className="margin-top-10 margin-bottom-2 control-label">{i18.CUSTOMER._collectorCode}</label>
                        <select value={this.state.fields.collector_code_fk_id.value}
                                name='collector_code_fk_id'
                                id='collector_code_fk_id'
                                onChange={(event) => this.onElementChange(event)}
                                className='minimal-100  form-control'>
                            <option value='' key='0'>Kérjük válasszon</option>
                            {this.props.vatCollectorCodes.map((el) => {
                                return <option
                                    value={el.id}
                                    key={el.id}>{el.code}&nbsp;({el.title})</option>
                            })}
                        </select>
                        <Field
                            type='text' id='vat_degree' name='vat_degree'
                            label={i18.CUSTOMER._vatDegreeNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                            classInput='form-control' setValue={this.setValue.bind(this)}
                            state={this.state} style={{width: '100%', 'minWidth': '350px'}}
                            disabled={this.state.fields.collector_code_fk_id.value === 3}
                        />
                        <label htmlFor="type" className="margin-top-10 margin-bottom-2 control-label">{i18.COMMON._typeOfRule}</label>
                        <select value={this.state.fields.type.value}
                                name='type'
                                id='type'
                                onChange={(event) => this.onElementChange(event)}
                                className='minimal-100  form-control'>
                            <option value="temporarily">{i18.COMMON._temporarirlyRule}</option>
                            <option value="final">{i18.COMMON._finalRule}</option>
                        </select>
                    </div>

                    <div className='modal-footer text-center'>
                        <a onClick={() => this.updateRule()} className='btn btn-success btn-sm'>{i18.COMMON._save}</a>
                        &nbsp;&nbsp;&nbsp;
                        <a onClick={() => this.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                    </div>
                </Modal>
                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Rules




// WEBPACK FOOTER //
// ./src/components/customer/rules.js